import { createElement, FC, useContext } from 'react';

import Language from '../../entity/Language';
import Component from '../component/compound/HeadBar';
import { context as ConfigContext } from '../context/config';
import { context as DependencyContext } from '../context/dependency';
import { context as StateContext } from '../context/state';

type Props = {
  className?: string;
};

const HeadBar: FC<Props> = ({ className }) => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);
  const config = useContext(ConfigContext);
  const drawerOpen = state.drawerOpen;
  const organizations = state.organization.organizations;
  const currentOrgOrAccount = state.currentOrgOrAccount;

  return !state.fatalError &&
    !state.authentication.done &&
    state.authentication.fetching === 0 &&
    state.authentication.signedInUser &&
    !state.location.pathname.includes('questionnaire') ? (
    <Component
      signedInUser={state.authentication.signedInUser}
      profileWebUrl={`${config.PROFILE_WEB_URL}/users/${state.authentication.signedInUser.id}`}
      onClickSignOut={() => dependency.authenticationUsecase.signOut()}
      triggerDrawer={() => dependency.drawerOpenUsecase.setOpen(!drawerOpen)}
      organizations={organizations}
      onSubmit={(lang: Language) => dependency.userUsecase.updateUserLang(lang)}
      currentOrgOrAccount={currentOrgOrAccount}
      setCurrentOrgOrAccount={dependency.organizationUsecase.setCurrentOrgOrAccount}
      drawerOpen={drawerOpen}
      className={className}
    />
  ) : null;
};

export default HeadBar;
